enum NotificationsListRoutes {
  List = '/notifications',
  Item = '/notifications/:id',
}

export default NotificationsListRoutes
